'use strict';
import angular from 'angular';
import $ from 'jquery';

angular.module('lookup.ctrls', [])
    .controller('LookupContentController', LookupContentController)
    .controller('LookupTypesController', LookupTypesController);

LookupContentController.$inject = ['$rootScope', '$scope', '$stateParams', 'ProductService', 'UserService', 'ClusterService', '$state', '$modal', '$ioAlert', 'ModalService', 'filterFilter', 'FormService'];

// Be careful here with the lookup_content.id, because this id is not always taken from the same source.  There are 2 cases:
//
// 1) If the associated lookup type has no content-key, then the id is from tbl__tapio_lookup_content.id, as we would
//    normally expect.
//
// 2) If the associated lookup type does have a content-key, then this id is the id from that content-key's source table.
//    This could, for example, but tbl__clients, or tbl__tapio_department, etc.  Any one of the various content-keys we
//    have. In this case, the tbl__tapio_lookup_content.id is returned from the backend via the lookup_content_id field,
//    if one is present.  One will be present only if that lookup content value has a parent-child association,
//    or if it overrides the lookup value.  So we have sparse tbl__tapio_lookup_content entries, but we always have
//    an underlying content-key source.

function LookupContentController($rs, $scope, $stateParams, ProductService, UserService, ClusterService, $state, $modal, $ioAlert, ModalService, filterFilter, FormService) {
    $scope.lookupId = $stateParams.typeId;
    $scope.parentLookupTypeId = $stateParams.parentLookupTypeId;
    $scope.contentKey = $stateParams.contentKey;
    $scope.lookupContents = [];
    $scope.sortReverse = false;
    $scope.sortType = 'id';
    $scope.parentContentKeySourceIdToNameMap = new Map();
    $scope.parentContentKeySourceNameToIdMap = new Map();
    $scope.disableBtnAction = false;

    const ad_contents = [
        'dfp_adsizes',
        'google_ads_countries',
    ];

    var getlookupContents = function() {
        // If there's a parent for the corresponding lookup type, fetch the parent's lookup contents as well, so it's
        // available for displaying the parent content key, and choosing a new value.
        // Do this before fetching the actual lookup contents we want to display here because we need this to get the
        // parent names (from the parent id).
        if ($scope.parentLookupTypeId) {
            ProductService.getLookupContent($scope.parentLookupTypeId, ClusterService.clusterIds[0]).then(function(success) {
                // Create hash map equivalents to quickly map a content key source id to a name (for parents), and vice-versa.
                for (var i = 0, len = ProductService.lookupContents.length; i < len; i++) {
                    const id = ProductService.lookupContents[i].id;
                    const name = ProductService.lookupContents[i].lookup_value;
                    $scope.parentContentKeySourceIdToNameMap.set(id, name); // Used to display name rather than stored id
                    $scope.parentContentKeySourceNameToIdMap.set(name, id); // Used to find id to write to DB after users makes selection
                }

                // We have to do one after the other, because me must be sure to receive the "parent" query results before
                // this next one, to have the maps populated.
                return ProductService.getLookupContent($scope.lookupId, ClusterService.clusterIds[0]);

            }, function(error) {
                console.log("error loading lookup contents for parent lookup type Id: " + $scope.parentLookupTypeId);
            }).then(function (success) {
                $scope.lookupContents = ProductService.lookupContents;

                // Set the ids as numbers and not strings for proper sorting.
                // Fetch the parent name using the map created above.
                if ($scope.lookupContents.length > 0) {
                    for (var i = 0, len = $scope.lookupContents.length; i < len; i++) {
                        $scope.lookupContents[i].id = parseInt($scope.lookupContents[i].id);
                        $scope.lookupContents[i].parent_content_key_source_name =
                            $scope.parentContentKeySourceIdToNameMap.get($scope.lookupContents[i].parent_content_key_source_id);
                    }
                }
            }, function (error) {
                console.log("error loading lookup contents for lookup type Id: " + $scope.lookupId);
            });

        } else {
            // This is the "no parent" case: our lookup type does not have a parent lookup type, so no parent lookup
            // content either.
            ProductService.getLookupContent($scope.lookupId, ClusterService.clusterIds[0]).then(function (success) {
                $scope.lookupContent = [];
                $scope.lookupContents = ProductService.lookupContents;
                if (ad_contents.includes($scope.contentKey)) {
                    // Set dfp_adsizes ids as actual values not numbers because dfp_adsizes ids are may be numbers or strings
                    if ($scope.lookupContents.length > 0) {
                        for (var i = 0, len = $scope.lookupContents.length; i < len; i++) {
                            $scope.lookupContents[i].id = $scope.lookupContents[i].id;
                        }
                    }
                } else {
                    // Set the ids as numbers and not strings for proper sorting.
                    if ($scope.lookupContents.length > 0) {
                        for (var i = 0, len = $scope.lookupContents.length; i < len; i++) {
                            $scope.lookupContents[i].id = parseInt($scope.lookupContents[i].id);
                        }
                    }
                }
            }, function (error) {
                console.log("error loading lookup contents for lookup type Id: " + $scope.lookupId);
            });
        }
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        if ($scope.lookupId) {
            getlookupContents();
        }
    });
    $scope.updateLookupContents = function(){
        ProductService.getUpdatelookupContents($scope.lookupId,ClusterService.clusterIds[0]).then(function (success) {
            $scope.lookupContents = ProductService.lookupContents;
            if ($scope.contentKey == 'dfp_adsizes') {
                if ($scope.lookupContents.length > 0) {
                    for (var i = 0, len = $scope.lookupContents.length; i < len; i++) {
                        $scope.lookupContents[i].id = $scope.lookupContents[i].id;
                    }
                }
            } else {
                if ($scope.lookupContents.length > 0) {
                    for (var i = 0, len = $scope.lookupContents.length; i < len; i++) {
                        $scope.lookupContents[i].id = parseInt($scope.lookupContents[i].id);
                    }
                }
            }
        }, function (error) {
            console.log("error loading Update lookup contents for lookup type Id: " + $scope.lookupId);
        });
    }

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    function showModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    $scope.deleteContent = function(content) {
        if ($scope.contentKey && !content.lookup_content_id) {
            console.log("Cannot delete source entry for lookup type with content-key defined");
            return;
        }
        showModal('deleteLookupContent', {
            lookupContentId: content.lookup_content_id || content.id
        }).result.then(function(lookupContentId) {
            //call my remove function, then refetch my list, then set my list, then sleep
            ProductService.deleteLookupContent(lookupContentId).then(function(data) {
                getlookupContents();
            })
        }, function(cancel) {
            //do nothing
        });
    };

    $scope.addContent = function(lookupContent) {
        $scope.isNew = (lookupContent == null);

        showModal('createLookupContent', {
            lookupContent: lookupContent,
            parentContentKeySourceNames: $scope.parentLookupTypeId ? Array.from($scope.parentContentKeySourceNameToIdMap.keys()) : undefined
        }).result.then(function(formObj) {
            formObj.lookup_type_id = $scope.lookupId;
            if ($scope.parentLookupTypeId) {
                formObj.parent_content_key_source_id = $scope.parentContentKeySourceNameToIdMap.get(formObj.parent_content_key_source_name);
                delete formObj.parent_content_key_source_name;
                delete formObj.parentContentKeySourceNames;
            }
            const lookupContentExist = $scope.lookupContents.find(
                content => content.lookup_value == formObj.lookupValue && content.parent_content_key_source_id == formObj.parent_content_key_source_id
            );
            if ($scope.isNew) {
                if (lookupContentExist) {
                    $ioAlert.show('Error!', 'Lookup content already exists', 'error');
                    return;
                }
                ProductService.saveLookupContent($scope.lookupId, formObj).then(function(data) {
                    data.id = parseInt(data.id);
                    data.parent_content_key_source_name =
                        $scope.parentContentKeySourceIdToNameMap.get(data.parent_content_key_source_id);
                    $scope.lookupContents.push(data);
                    $ioAlert.show('', 'Lookup Content created successfully', 'success');
                }, function(error) {
                    console.log(error.data.error);
                    $ioAlert.show('Error!', error.data.error, 'error');
                });
            } else {
                if (lookupContentExist) {
                    if (lookupContentExist.id != lookupContent.id) {
                        $ioAlert.show('Error!', 'Lookup content already exists', 'error');
                        return;
                    }
                }
                formObj.lookup_content_id = lookupContent.lookup_content_id;
                ProductService.updateLookupContent($scope.lookupId, formObj).then(function(data) {
                    for (var i = 0, len = $scope.lookupContents.length; i < len; i++) {
                        if ($scope.lookupContents[i].id == data.id) {
                            data.id = parseInt(data.id);
                            data.parent_content_key_source_name =
                                $scope.parentContentKeySourceIdToNameMap.get(data.parent_content_key_source_id);
                            $scope.lookupContents[i] = data;
                        }
                    }
                    $ioAlert.show('', 'Lookup Content updated successfully', 'success');
                }, function(error) {
                    console.log(error.data.error);
                    $ioAlert.show('Error!', error.data.error, 'error');
                });
            }
        }, function(cancel) {});
    };
    // search based on user text
    $scope.updateSearch = function() {
        if ($scope.searchLookupContents) {
            $scope.filteredLookupContents = filterFilter($scope.lookupContents, $scope.searchLookupContents);
        }
    };

    $scope.backtoTypes = function() {
        $state.go('lookupTypes');
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.init = function() {
        ClusterService.initCluster($rs.userRole);
        if ($scope.lookupId) {
            getlookupContents();
        }
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };
    $scope.init();
    UserService.adjustStickyHeaderWindowResize();

}

LookupTypesController.$inject = ['$rootScope', '$scope', 'ProductService', 'ClusterService', '$modal', '$ioAlert', '$state', 'UserService','ModalService', '$confirm', 'filterFilter', 'FormService'];

function LookupTypesController($rs, $scope, ProductService, ClusterService, $modal, $ioAlert, $state, UserService, ModalService, $confirm, filterFilter, FormService) {

    $scope.lookupTypes = [];
    $scope.lookupContentKeys = [];
    $scope.uploadMedia = {};
    $scope.sortReverse = false;
    $scope.sortType = 'id';
    $scope.disableBtnAction = false;
    $scope.showSynchronized = false;

    var getLookupTypes = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetch LookUp Types";
        ProductService.getLookupTypes().then(function(success) {
            //id field changing from string to number type
            for(var i = 0, len = ProductService.lookupTypes.length; i<len; i++){
                ProductService.lookupTypes[i].id = Number(ProductService.lookupTypes[i].id);
                // Fetch the parent's name since it's located in another row.  It will often be empty and we don't want
                // to display anything in that case.
                for (var j = 0; j < len; j++) {
                    if (ProductService.lookupTypes[i].parent_lookup_type_id == ProductService.lookupTypes[j].id) {
                        ProductService.lookupTypes[i].parent_lookup_type_name = ProductService.lookupTypes[j].name;
                        break;
                    }
                }
                if (!$scope.showSynchronized && ProductService.lookupTypes[i].__NEW_ORDERS_CONTENT_SET_ID__) {
                    $scope.showSynchronized = true;
                }
            }
            $scope.lookupTypes = ProductService.lookupTypes
            $rs.loadingInProgress = false;
        }, function(error) {
            console.log("error loading lookup types");
            $rs.loadingInProgress = false;
        });
    };

    // search based on user text
    $scope.updateSearch = function() {
        if ($scope.searchLookupTypes) {
            $scope.filteredLookupTypes = filterFilter($scope.lookupTypes, $scope.searchLookupTypes);
        }
    };

    var getLookupContentKeys = function() {
        ProductService.getLookupContentKeys().then(function(response) {
            if (response.contentKeys && response.contentKeys.length > 0) {
                $scope.lookupContentKeys = response.contentKeys;
            }
        }, function(error) {
            console.log("error loading lookup content keys");
        });
    };

    function showModal(type, data) {
        data.lookupContentKeys = $scope.lookupContentKeys;
        data.lookupTypeIdNames = [];
        for(var i = 0; i < $scope.lookupTypes.length; i++){
            data.lookupTypeIdNames[i] =  $scope.lookupTypes[i].name;
            if (data.lookupType && data.lookupType.parent_lookup_type_id == $scope.lookupTypes[i].id) {
                data.parentLookupTypeName = $scope.lookupTypes[i].name;
            }
        }
        return $modal.open(ModalService.returnModalType(type, {
            data: data
        }));
    }

    $scope.importLookup = function() {
        if ($scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            $ioAlert.show('', 'File is being uploaded dont refresh the page', 'success');
            ProductService.importLookup($scope.uploadMedia.file).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                } else {
                    getLookupTypes();
                    getLookupContentKeys();
                    $ioAlert.show('', 'File Imported successfully', 'success');
                }

            }, function(error) {
                console.log("error loading lookup content keys");
            });
        } else {
            //$ioAlert.show("Error!", "Upload at least one file", 'error');
        }
    };

    $scope.exportLookup = function() {
        ProductService.exportLookup().then(function(response) {
            var csvString = response.data;
            var a = $('<a/>', {
                style: 'display:none',
                href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                download: 'LookupTypes.csv'
            }).appendTo('body');
            a[0].click();
            a.remove();
        }, function(error) {
            console.log("error loading lookup content keys");
        });
    }

    $scope.addType = function(lookupType) {
        $scope.isNew = (lookupType == null);
        showModal('createLookupType', {
            lookupType: lookupType
        }).result.then(function(formObj) {
            var param = {};

            param['name'] = formObj.name;
            param['contentKey'] = formObj.content_key;
            $scope.newParentName = formObj.parent_lookup_type_name;
            // Map the parent lookup type name to an id, for writing to the database
            for (var i = 0, len = $scope.lookupTypes.length; i < len; i++) {
                if ($scope.lookupTypes[i].name == formObj.parent_lookup_type_name) {
                    param['parentLookupTypeId'] = $scope.lookupTypes[i].id;
                    break;
                }
            }

            if ($scope.isNew) {
                ProductService.saveLookupType(param).then(function(data) {
                    data.id = Number(data.id);
                    data.parent_lookup_type_name = $scope.newParentName;
                    $scope.lookupTypes.push(data);
                    $ioAlert.show('', 'Lookup type created successfully', 'success');
                }, function(error) {
                    console.log(error.data.error);
                    $ioAlert.show('Error!', error.data.error, 'error');
                });
            } else {
                param['id'] = formObj.id;

                ProductService.updateLookupType(param).then(function(data) {
                    data.parent_lookup_type_name = $scope.newParentName;
                    for (var i = 0, len = $scope.lookupTypes.length; i < len; i++) {
                        if ($scope.lookupTypes[i].id == data.id) {
                            data.id = Number(data.id);
                            $scope.lookupTypes[i] = data;
                        }
                    }
                    $ioAlert.show('', 'Lookup type updated successfully', 'success');
                }, function(error) {
                    console.log(error.data.error);
                    $ioAlert.show('Error!', error.data.error, 'error');
                });
            }
        }, function() {
            //console.log("cancel");
        })
    };

    $scope.gotoTieredLookups = function() {
        $state.go('tieredLookups');
    };
    $scope.gotoPackages = function() {
        $state.go('Packagesview');
    };

    $scope.viewContents = function(lookupType) {
        $state.go('lookupContents', {
            'typeId': lookupType.id,
            'parentLookupTypeId': lookupType.parent_lookup_type_id,
            'contentKey': lookupType.content_key
        })
    };
    $scope.deleteType = function(lookupType) {
        var index = $scope.lookupTypes.indexOf(lookupType);
        $confirm.open({
            size: 'sm',
            text: 'Are you sure you want to delete this LookupType?'
        }).then(function(success) {
            ProductService.deleteLookupType(lookupType.id).then(function(success) {
                $ioAlert.show('lookupType Deleted', 'lookupType has been deleted successfully', 'success');
                $scope.lookupTypes.splice(index, 1);
            }, function(error) {
                console.log(error.data.error);
                $ioAlert.show('Error!', error.data.error, 'error');
            });
        });
    }

    $scope.deleteTiredLookup = function(lookupType) {
        if (lookupType.id) {
            ProductService.deleteLookupType(lookupType.id).then(function(data) {
                $ioAlert.show('', 'Lookup type deleted successfully', 'success');
                for (var i = 0; i < $scope.lookupTypes.length; i++) {
                    if ($scope.lookupTypes[i] && $scope.lookupTypes[i].id === lookupType.id) {
                        $scope.lookupTypes.splice(i, 1);
                        break;
                    }
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.init = function() {
        ClusterService.initCluster($rs.userRole);
        getLookupTypes();
        getLookupContentKeys();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };

    $scope.init();
    UserService.adjustStickyHeaderWindowResize();
}